module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "global-answers"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('md-button', {
    staticClass: "md-raised",
    class: {
      active: _vm.showVoteNumbers
    },
    nativeOn: {
      "click": function($event) {
        _vm.showVoteNumbers = !_vm.showVoteNumbers
      }
    }
  }, [_vm._v("Válaszadók számának mutatása")])], 1), _vm._v(" "), _vm._l((_vm.notifications), function(notification) {
    return _c('div', {
      staticClass: "card question"
    }, [_vm._v("\n\t\tKérdés: " + _vm._s(notification.title)), _c('br'), _vm._v(" "), _c('p', {
      staticClass: "subtitle"
    }, [_vm._v(_vm._s(notification.body))]), _vm._v(" "), _c('div', {
      staticClass: "card"
    }, _vm._l((notification.options), function(option) {
      return _c('div', {
        staticClass: "option"
      }, [_c('p', [_vm._v(_vm._s(option.title)), (_vm.showVoteNumbers) ? _c('span', [_vm._v(" - " + _vm._s(option.answerCount))]) : _vm._e(), _vm._v(" - " + _vm._s(_vm.notificationPercentage(option, notification)) + "%")]), _vm._v(" "), _c('div', {
        staticClass: "progress"
      }, [_c('progressbar', {
        attrs: {
          "now": _vm.notificationPercentage(option, notification),
          "label": "",
          "type": "primary",
          "striped": "",
          "animated": ""
        }
      })], 1)])
    }))])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-417525cb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Answers.vue
// module id = 553
// module chunks = 2